import { FacetFilter, FacetFilterType, useFacetsFilters } from '@/app/composable';
import { computed } from '@vue/composition-api';

export function useContractFacets(get: any) {
    const { valueLabel, reducedFacetsFilters, defaultValue } = useFacetsFilters();

    const contractFacets = computed(
        (): Record<string, FacetFilter> => ({
            status: {
                label: 'Status',
                type: FacetFilterType.Checkbox,
                default: defaultValue(get, 'status'),
                valueLabel,
            },
            type: {
                label: 'Contract Type',
                type: FacetFilterType.Checkbox,
                default: defaultValue(get, 'type'),
                valueLabel,
            },
        }),
    );

    const reducedContractFacets: any = reducedFacetsFilters(contractFacets);

    return { contractFacets, reducedContractFacets };
}
